import * as yup from 'yup';

export const MaterialEditFormSchema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    shortName: yup.string().required(t('form.errors.missingShortName')),
    subMaterials: yup.array().of(
      yup.object().shape({
        name: yup.string().required(t('form.errors.missingSubMaterialName')),
      }),
    ),
  });
